//   
// AGNES - Technical Support Web
//   
// TechnicalSupportDetailController.js
//   
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//   
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//   
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//   
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
// 

angular.module("Agnes")
    .controller("MenuPricingGenerateReportController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "menuItemTypes", "$oidc", 'menuTypes',
        function ($scope, $sessionStorage, $http, $activity, $notification, menuItemTypes, oidc, menuTypes) {

            var countries = [];
            var brands = [];

            $scope.brands = [...brands];
            $scope.menuItemTypes = [...menuItemTypes];
            $scope.menuTypes = [...menuTypes];
            $scope.countries = [];
            $scope.selectedBrands = [];
            $scope.selectedMenuItemTypes = [];
            $scope.selectedMenuTypes = [];
            $scope.selectedCountries = [];

            $scope.generate = function () {
                return $scope.$close(
                    {
                        selectedBrands: $scope.selectedBrands.length === 0 ? [...brands] : $scope.selectedBrands,
                        selectedMenuItemTypes: $scope.selectedMenuItemTypes.length === 0 ? [...menuItemTypes] : $scope.selectedMenuItemTypes,
                        selectedMenuTypes: $scope.selectedMenuTypes.length === 0 ? [...menuTypes] : $scope.selectedMenuTypes,
                        selectedCountries: $scope.selectedCountries.length === 0 ? [...countries] : $scope.selectedCountries
                    });
            }

            $scope.load = function () {
                $activity.start();
                $http
                    .get('api/country/dealers-countries', {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        countries = [...response.data];
                        $scope.countries = countries;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    })
                    .then(function () {
                        $activity.finish();
                    })
                $http
                    .get('api/brand', {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        brands = [...response.data];
                        $scope.brands = brands;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    })
            };

            $scope.load();
        }
    ]);